import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteCategoriesMutationProps = {
	ids: number[]
	onSettled: () => void
}

export const useDeleteCategoriesMutation = ({
	ids,
	onSettled
}: UseDeleteCategoriesMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: deleteCategoriesMutation } = useMutation({
		mutationFn: () => {
			return axiosPrivate.post(apiRoutes.categoriesDelete, { ids })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Categories deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.categories.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteCategoriesMutation
	}
}
